<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="90px">
        <el-form-item label="手机号">
          <el-input v-model="searchData.mobile" size="small" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" icon="el-icon-search" @click="getList()">搜索</el-button>
          <el-button type="info" size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="header-tabs">
      <el-button
          v-checkbtn="isShowBtn(AUTH_BTN.allow_roster_list_add)"
          style="margin-left:20px"
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="showRosterDialog"
      >新增</el-button>
    </div>
    <el-divider></el-divider>
    <tp-table
        :tableData="list"
        :is-need-serial-number="true"
        :columns="columns"
        :totalNum="total"
        :current-page.sync="currentPage"
        :pageSize.sync="pageSize"
    />

    <!-- 加入白名单 -->
    <el-dialog :visible.sync="dialogRoster" width="50%">
      <div class="roster-form">
        <el-form ref="rosterForm" :model="rosterFormData" label-width="80px">
          <el-form-item label="手机号" style="width: 300px;">
            <el-input
                placeholder="请输入手机号"
                v-model="rosterFormData.mobile"
                clearable
                size="small"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input
                placeholder="请输入备注"
                v-model="rosterFormData.remark"
                clearable
                type="textarea"
                size="small"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="dialogRoster = false" size="small">取 消</el-button>
        <el-button type="primary" @click="submitRoster" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getListAPI, addRosterAPI, delRosterAPI } from './api';
import { authBtnMixin } from '@/mixins/authBtnMixin';

const columns = [
  {
    label: '手机号',
    prop: 'mobile',
    minWidth: '120',
    customRender(h, row) {
      return <p>{row['mobile']}</p>
    }
  },
  {
    label: '姓名',
    prop: 'idName',
    minWidth: '120',
    customRender(h, row) {
      return <p>{row?.['member']?.['idName']}</p>
    }
  },
  {
    label: '注册渠道',
    prop: 'registerChannelName',
    minWidth: '150',
    customRender(h, row) {
      return <p>{row?.['member']?.['registerChannelName']}</p>
    }
  },
  {
    label: '注册时间',
    prop: 'createTime',
    minWidth: '180',
    customRender(h, row) {
      return <p>{row?.['member']?.['createTime']}</p>
    }
  },
  {
    label: '操作记录',
    prop: 'action',
    minWidth: '240',
    customRender(h, row) {
      return (
        <div>
          <p>操作人：{row['actionUserName']}</p>
          <p>操作时间：{row['createTime']}</p>
        </div>
      )
    }
  },
  {
    label: '备注',
    prop: 'remark',
    minWidth: '150',
    customRender(h, row) {
      return <p>操作人：{row['remark']}</p>
    }
  },
  {
    label: '操作',
    width: '150',
    fixed: 'right',
    customRender(h, row) {
      return (
        <div>
          <el-link
              disabled={!this.isShowBtn(this.AUTH_BTN.allow_roster_list_del)}
              underline={false}
              type="danger"
              onClick={() => this.submitDelete(row.id)}
              style="margin: 2px;"
          >
            <span>删除</span>
          </el-link>
        </div>
      )
    }
  }
];

export default {
  name: 'RosterAllowList',
  mixins: [authBtnMixin],
  data() {
    return {
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        rosterType: 1,
        mobile: '',
      },
      dialogRoster: false,
      rosterFormData: {
        rosterType: 1,
        mobile: '',
        remark: '',
      },
    }
  },
  provide() {
    return {
      context: this
    }
  },
  activated() {
    this.getList()
  },
  watch: {
    currentPage() {
      this.getList()
    },
    pageSize() {
      this.getList()
    }
  },
  mounted() {
    this.getList()
  },

  methods: {
    async getList() {
      const { mobile, rosterType } = this.searchData;
      let params = { page: this.currentPage, pageSize: this.pageSize, mobile, rosterType };
      const res = await getListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    },
    showRosterDialog() {
      this.rosterFormData.mobile = '';
      this.rosterFormData.remark = '';
      this.dialogRoster = true;
    },
    submitRoster() {
      this.$confirm(`确定将该手机号加入白名单吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            addRosterAPI(this.rosterFormData).then(() => {
              this.getList();
              this.$message.success('操作成功');
            })
          })
          .catch(() => {
            this.$message({ type: 'info', message: '已取消操作' });
          })
          .finally(() => {
            this.dialogRoster = false;
          })
    },
    submitDelete(id) {
      this.$confirm(`确定删除该白名单吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            delRosterAPI({ id }).then(() => {
              this.getList();
              this.$message.success('操作成功');
            })
          })
          .catch(() => {
            this.$message({ type: 'info', message: '已取消操作' });
          })
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 35px;
        .el-input {
          width: 250px;
        }
        .el-date-editor {
          .el-range-separator {
            padding: 0;
          }
          .el-range-input {
            width: 35%;
          }
        }
      }
    }
  }
  .header-tabs {
    margin-bottom: 20px;
  }
  .el-date-editor .el-range-separator {
    padding: 0;
  }
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
  .tp-table {
    .el-table__fixed-right {
      height: 100% !important;
    }
  }

  .roster-form {
    width: 80%;
    font-size: 15px;
    line-height: 20px;
    & > span {
      display: flex;
      justify-content: center;
      font-weight: 500;
      margin: 10px 0;
    }
  }
}
</style>
